import React, { useState, useRef, useEffect, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { userStatus, errorReason } from '~data/selectors/user'
import { registerWithPassword } from '~data/actions/user'

import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Button, Layout, Text, Label, HeaderTitle as Title, Header, Preloader } from '~ui'
import Social from '../social'
import { Error } from '~co/overlay/dialog'

export default function AccountSignup() {
    const dispatch = useDispatch()
    const status = useSelector(state => userStatus(state).register)
    const error = useSelector(state => errorReason(state).register)

    const [form, setForm] = useState({ name: '', email: '', password: '' })

    const prevError = useRef(error)
    useEffect(() => {
        if (prevError.current != error)
            Error(error)
        prevError.current = error
    }, [error])

    const onChangeValue = useCallback(
        e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value })),
        []
    )

    const onSubmit = useCallback(
        e => {
            e.preventDefault()
            dispatch(registerWithPassword(form))
        },
        [dispatch, form]
    )

    return (
        <form onSubmit={onSubmit}>
            <Helmet><title>{t.s('register')}</title></Helmet>
            <Header data-fancy>
                <Title>{t.s('startCollecting')}</Title>
            </Header>

            <Layout>
                <Label>{t.s('username')}</Label>
                <Text
                    type='text'
                    name='name'
                    disabled={status == 'loading'}
                    autoFocus
                    required
                    pattern='[a-zA-Z0-9][a-zA-Z0-9\-_]*'
                    autoCapitalize='none'
                    spellCheck='false'
                    title={t.s('regexAz09_-')}
                    value={form.name}
                    onChange={onChangeValue} />

                <Label>{t.s('email')}</Label>
                <Text
                    type='email'
                    name='email'
                    inputMode='email'
                    autoCapitalize='none'
                    spellCheck='false'
                    disabled={status == 'loading'}
                    required
                    value={form.email}
                    onChange={onChangeValue} />

                <Label>{t.s('password')}</Label>
                <Text
                    type='password'
                    name='password'
                    disabled={status == 'loading'}
                    required
                    value={form.password}
                    onChange={onChangeValue} />

                {status == 'loading' ? (
                    <Button variant='flat' data-block>
                        <Preloader />
                    </Button>
                ) : (
                    <Button
                        as='input'
                        type='submit'
                        variant='primary'
                        data-block
                        value={t.s('register')} />
                )}

                <div className={'ui-accept-licence'}>
                    <span dangerouslySetInnerHTML={{ __html: t.format('privacyTermsFull', `<a href='https://save.ltdhunt.com/terms' target='_blank'>${t.s('termsOfService')}</a>`, `<a href='https://save.ltdhunt.com/privacy' target='_blank'>${t.s('privacyPolicy')}</a>`) }} />
                </div>

                <Social
                    disabled={status == 'loading'} />

                <Button
                    as={Link}
                    to='/account/login'
                    variant='accent'
                    data-block>
                    {t.s('signIn')}
                </Button>
            </Layout>
        </form>
    )
}
